import {Component, OnInit} from '@angular/core';
import {AppService} from 'src/app/app.service';

@Component({
  selector: 'fx-affiliate',
  templateUrl: './affiliate.component.html',
  styleUrls: ['./affiliate.component.sass'],
})
export class AffiliateComponent implements OnInit {
  data: any = [];
  constructor(private appService: AppService) {}

  ngOnInit(): void {}

}
